import { useDispatch } from "react-redux";

import FMFilterComponent from "./FMFilterComponent";
import { getAuthData } from "../../../services/storage/LocalStorage";
import { MessageTypeConstants } from "../../../services/bot/Message";
import { processSendMessage } from "../../../services/bot/conversation/SendMessage";
import { updateFilterFlags } from "../../../state/actions/tabStack";
import { renderNonconversationalNewFilter } from "../../../state/actions/filters";
import { setSearchLoader } from "../../../state/actions/loader";


const FMFilter = ({ options, parentTabId, conversation }) => {
	const dispatch = useDispatch();
	const { user: { userTimezone } } = getAuthData();
	const defaultUserTimezone = "Etc/UTC";

	const handleAction = (action, activeFilterName, filteredColumns = null, deleteAction = false) => {
		const responseChat = {
			messageType: MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE,
			message: {
				controlId: options?.controlId,
				tabId: options?.parent?.length ? parentTabId : options?.tabId,
				action,
				...(deleteAction ? {} : { tz: userTimezone || defaultUserTimezone }),
				content: {
					activeFilterName,
					...(filteredColumns ? { field: filteredColumns } : {}),
				},
			},
			options: options || {},
		};

		if (options?.availableFilters && !options?.availableFilters?.isNewFilter) {
			modifyAvailableFilters(options?.activeFilterName, activeFilterName);
			setActiveFilterName(activeFilterName);
		}

		// if(action === "filter"){
		// 	dispatch(setSearchLoader(true));
		// }
		processSendMessage(responseChat, true);
	};


	const handleClearFilterAction = () => {
		const responseChat = {
			messageType: MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE,
			message: {
				controlId: options?.controlId,
				tabId: options?.parent?.length ? parentTabId : options?.tabId,
				action: "clearFilter",
			},
			options: options || {},
		};

		processSendMessage(responseChat, true);
	};


	const modifyAvailableFilters = (oldAvailableFilterName, newAvailableFilterName) => {
		const index = options?.availableFilters?.indexOf(oldAvailableFilterName);
		if (index !== -1) {
			options.availableFilters[index] = newAvailableFilterName;
		}
	};

	const updateReduxFlags = (localFilterFlag) => {
		let message = {
			options: {
				...options,
				parentTabId,
				...localFilterFlag,
			},
		};
		dispatch(updateFilterFlags(conversation, message));
	};


	const handleConfirm = () => {
		const responseChat = {
			messageType: MessageTypeConstants.MESSAGE_TYPE_FORM_RESPONSE,
			message: {
				controlId: options?.controlId,
				tabId: options?.parent?.length ? parentTabId : options?.tabId,
				action: "confirm",
				content: {
					activeFilterName: options?.activeFilterName,
					field: options?.filteredColumns ?? [],
				},
			},
			options: options || {},
		};

		processSendMessage(responseChat);
	};


	const handleCancel = () => {
		if (!options?.allowClose) return;

		const responseChat = {
			messageType: MessageTypeConstants.MESSAGE_TYPE_FORM_RESPONSE,
			message: {
				controlId: options?.controlId,
				tabId: options?.parent?.length ? parentTabId : options?.tabId,
				action: "cancel",
				content: {
					activeFilterName: options?.activeFilterName,
					field: options?.filteredColumns ?? [],
				},
			},
			options: options || {},
		};
		processSendMessage(responseChat);
	};


	const addNewFilter = () => {
		dispatch(renderNonconversationalNewFilter(parentTabId));
	};

	const setActiveFilterName = (activeFilterName) => {
		options.activeFilterName = activeFilterName;
	};

	return (
		<FMFilterComponent
			options={options}
			setActiveFilterName={setActiveFilterName}
			handleAction={handleAction}
			updateReduxFlags={updateReduxFlags}
			handleConfirm={handleConfirm}
			handleCancel={handleCancel}
			addNewFilter={addNewFilter}
			handleClearFilterAction={handleClearFilterAction}
		/>
	);
};

export default FMFilter;
